import React, {useState} from "react";
import "./getintouch.scss";

const GetInTouch = () => {
	const [formData, setFormData] = useState ({
		name: "",
		email: "",
		message: "",
	});
	
	const handleChange = (e) => {
		setFormData ({...formData, [e.target.name]: e.target.value});
	};
	
	const handleSubmit = (e) => {
		e.preventDefault ();
		console.log ("Form submitted:", formData);
		alert ("Thank you! We will get back to you soon.");
		setFormData ({name: "", email: "", message: ""});
	};
	
	return (
		<div className="mainGetInTouch">
			<div className="GetInTouchTitle">
				<h2>Get In Touch</h2>
			</div>
			<div className="subGetInTouch">
				<p>Have a question or want to work together? Fill out the form below and we’ll get back to you.</p>
				
				<form onSubmit={handleSubmit} className="contactForm">
					<div className="NameandEmail">
						<div className="NameInput">
							<input
								type="text"
								name="name"
								placeholder="Your Name"
								value={formData.name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="EmailInput">
							<input
								type="email"
								name="email"
								placeholder="Your Email"
								value={formData.email}
								onChange={handleChange}
								required
							/>
						</div>
					</div>
					
					<textarea
						name="message"
						placeholder="Your Message"
						rows="5"
						value={formData.message}
						onChange={handleChange}
						required
					></textarea>
					
					<button type="submit">Send Message</button>
				</form>
			</div>
		</div>
	);
};

export default GetInTouch;